import styled from 'styled-components'

const TimelineListItemContainer = styled.div`
  position: relative;
  padding-bottom: 2rem;
`

export default TimelineListItemContainer
